import { FieldConfig } from '../../common/field-types';
import { renderRateScheduleField } from '../_shared';
import {
  COMPENSATION_PLAN_OPTIONS,
  GENDER_OPTIONS,
  InsuredUniversityFormValues,
  PAYMENT_PERIODICITY_OPTIONS,
  RATE_MODE_OPTIONS,
  isFixedRate,
  isSteppedRate,
} from './schema';

// eslint-disable-next-line max-len
export const INSURED_UNIVERSITY_FIELDS: readonly FieldConfig<InsuredUniversityFormValues>[] = [
  { key: 'date_of_birth', label: 'Fecha de nacimiento', kind: 'date' },
  {
    key: 'gender', label: 'Género', kind: 'select', options: GENDER_OPTIONS,
  },
  {
    key: 'rate_mode', label: 'Modo de tasa', kind: 'select', options: RATE_MODE_OPTIONS,
  },
  {
    key: 'projection_rate', label: 'Tasa de proyección', kind: 'number', hint: 'Anual, ej. 0.0331', step: 0.0001, visibleWhen: isFixedRate,
  },
  {
    key: 'projection_rate_schedule',
    label: 'Tramos de tasa',
    kind: 'custom',
    hint: 'Cada tramo aplica hasta el mes "Hasta" inclusive. El último puede dejarse "para siempre".',
    visibleWhen: isSteppedRate,
    render: renderRateScheduleField,
  },
  {
    key: 'compensation_plan', label: 'Plan de compensación', kind: 'select', options: COMPENSATION_PLAN_OPTIONS,
  },
  {
    key: 'payment_periodicity', label: 'Periodicidad de pago', kind: 'select', options: PAYMENT_PERIODICITY_OPTIONS,
  },
  {
    key: 'initial_contribution', label: 'Aporte único inicial', kind: 'number', hint: 'UF',
  },
  {
    key: 'unscheduled_annual_contribution', label: 'Aporte anual extra', kind: 'number', hint: 'UF',
  },
  {
    key: 'death_insured_capital', label: 'Capital muerte', kind: 'number', hint: 'UF (300 - 20.000)', colClassName: 'col-md-6',
  },
  {
    key: 'accidental_death_insured_capital', label: 'Capital muerte accidental', kind: 'number', hint: 'UF (= capital muerte o 0)', colClassName: 'col-md-6',
  },
  {
    key: 'itp_insured_capital', label: 'Capital ITP', kind: 'number', hint: 'UF (= capital muerte o 0)', colClassName: 'col-md-6',
  },
  {
    key: 'serious_illness_insured_capital', label: 'Capital enf. graves', kind: 'number', hint: 'UF (40% del capital muerte o 0)', colClassName: 'col-md-6',
  },
];
